import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './RelationTypesEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import lang from 'dojo/_base/lang';

class RelationTypesEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    selectContainer: HTMLDivElement;
    relationGroupsSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        var relationGroup = this.getAttributeValue("ref_relation_group.ID");
        this.relationGroupsSelect.setCatalog(MainCatalogs_Classes.RelationGroups, this.translate("General_Label_RelationGroups"), relationGroup);
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.RelationTypes;
    }

    private _onChangeSelect(): void {
        var value = this.relationGroupsSelect.getValue();
        this.setAttributeValue("ref_relation_group", value);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.relationGroupsSelect.placeAt(this.selectContainer);
        this.relationGroupsSelect.on("change", lang.hitch(this, this._onChangeSelect));

        this.relationGroupsSelect.setCatalog(MainCatalogs_Classes.RelationGroups, this.translate("General_Label_RelationGroups"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(RelationTypesEditor.prototype, {
  relationGroupsSelect: () => (new MainCatalogSelectV2()),
});
export default mdsWidget(RelationTypesEditor);